<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9995 19.9995C7.58875 19.9995 3.99951 16.4103 3.99951 11.9995C3.99951 7.58875 7.58875 3.99951 11.9995 3.99951C16.4103 3.99951 19.9995 7.58875 19.9995 11.9995C19.9995 16.4103 16.4103 19.9995 11.9995 19.9995ZM11.9995 5.13266C8.21198 5.13266 5.13266 8.21198 5.13266 11.9995C5.13266 15.787 8.21198 18.8664 11.9995 18.8664C15.787 18.8664 18.8664 15.787 18.8664 11.9995C18.8664 8.21198 15.787 5.13266 11.9995 5.13266Z"
      class="fill-current"
    />
    <path
      d="M11.2662 15.4276C11.1047 15.2887 11.0254 15.0763 11.0254 14.7873C11.0254 14.2293 11.3483 13.9488 11.9914 13.9488C12.6486 13.9488 12.9772 14.2293 12.9772 14.7873C12.9772 15.0763 12.8979 15.2887 12.7364 15.4276C12.575 15.5664 12.3313 15.6344 12.0027 15.6344C11.6713 15.6344 11.4277 15.5664 11.2662 15.4276ZM11.0735 8.36523H12.9347L12.7364 13.0933H11.2973L11.0735 8.36523Z"
      class="fill-current"
    />
  </svg>
</template>
